<section>
    <sticky-header
        [isHeaderFixed]="isHeaderFixed()"
        [bannerTop]="bannerTop()!"
        [activeLocation]="activeLocation()!"
        [isAngularApp]="isAngularApp()"
        [omer]="omer()"
        [dailyDonor]="dailyDonor()"
        [dailyTimeHeader]="dailyTimeHeader()"
        [hebrewDate]="hebrewDate()"
        [isAtTop]="isAtTop()"
        [headerMode]="headerMode()!"
        (toggleMenu)="toggleMenu()"
        (onSearchClick)="onSearchClick()"
        (toggleSocialShareBox)="socialShareService.toggleSocialShareBox($event)"
    >
    </sticky-header>
</section>

<!-- Padding element when the header in position fixed -->
<!-- In server headerMode value is injected -->
@if (showPadding()) {
    <div class="paddingElement"></div>
}

@if (showAdTop()) {
    <section class="ad-top-wrapper" id="adTop">
        <!-- Needed for dynamic ad loading when screen size changes -->
        @if (breakPointSizeService.isMobileSize()) {
            <ng-container *ngTemplateOutlet="adTop; context: { adCode: currAdTopType() }"></ng-container>
        } @else {
            <ng-container *ngTemplateOutlet="adTop; context: { adCode: currAdTopType() }"></ng-container>
        }
    </section>
}

@if (isBroadCastNotificationEnable()) {
    <div>
        @if (broadcastNotificationComponent(); as broadcastNotification) {
            <ng-container *ngComponentOutlet="broadcastNotification; inputs: broadcastNotificationInputs"></ng-container>
        }
    </div>
} @else {
    <!-- !isNihulPage(): a scroll subscription armed on a public page may still fire after navigating into the nihul -->
    @if (!isNihulPage() && !isAdFreePage() && isEnableAdStickyFooter() && breakPointSizeService.isMobileSize()) {
        <google-text-ad class="ad-sticky-bottom" [adCode]="adService.adsType.Leaderboardmobile"> </google-text-ad>
    }
    <!-- //  -->
    @if (!isNihulPage() && !isAdFreePage() && isEnableAdStickyFooter() && (breakPointSizeService.isTabletSize() || breakPointSizeService.isDesktopSize())) {
        <div class="footer-ad-wrapper" [class.closing]="isClosingStickyFooterAd()" (animationend)="onStickyFooterAdAnimationEnd($event)" #adsElement>
            <google-text-ad
                [adCode]="adService.adsType.SuperLeaderboard"
                [adStickyFooter]="true"
                [closeable]="true"
                (newItemEvent)="closeStickyFooterAd()"
            >
            </google-text-ad>
        </div>
    }
}

<header-menu
    [isMainMenuOpen]="isMainMenuOpen()"
    [isAngularApp]="isAngularApp()"
    [activeLocation]="activeLocation()!"
    [FocusSearch]="FocusSearch()"
    (onCloseMenu)="closeMenu()"
>
</header-menu>

@if (socialShareBoxComponent(); as socialShareBox) {
    @if (socialShareBoxModule(); as socialShareBoxNgModule) {
        <ng-container *ngComponentOutlet="socialShareBox; ngModule: socialShareBoxNgModule"></ng-container>
    }
}

<ng-template #adTop let-adCode="adCode">
    @if (adCode) {
        <google-text-ad
            (newItemEvent)="adService.setIsAdTopEnable($event)"
            (adLoaded)="adService.setIsAdTopLoaded(true)"
            (adinitLoad)="adService.setIsAdTopLoaded(false)"
            [adCode]="adCode"
        >
        </google-text-ad>
    }
    <!-- <section *ngIf="!isAdLoaded && breakPointSizeService.isMobileSize()" class="logoUntilAdShow">
  <yeshiva-logo></yeshiva-logo>
</section> -->

    <!-- [closeable]="true"  comment: once uppon a time, ads where closeable but then eveil Remy decided to cancle this option in order to make more $$$-->
</ng-template>
